import React from 'react'
import PropTypes from 'prop-types'

const ItemContentHandler = (props) => {
  const handleAction = (action, actionData) => {
    return props.itemContentActionHandler[action](actionData)
  }

  return (
    React.cloneElement(props.children, {
      onItemContentAction: handleAction
    })
  )
}

export default ItemContentHandler